export default "__VITE_ASSET__By4c68xm__"